import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { AppStoreService } from '../../services/app-store.service';
import { AppSharedService } from '../../services/app-shared.service';
import { AppUtilityService } from '../../services/app-utility.service';
import { Authentication } from '@hsi/ui-core';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [CommonModule, FormsModule, DatePipe]
})
export class LoginComponent implements AfterViewInit, OnInit {
  credentials: Authentication.Core.HsiAuthenticationCredentials = {
    loginId: '',
    password: '',
    tenant: ''
  };
  authenticatedUser: any = null;
  tennant: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public appStore: AppStoreService,
    public appShared: AppSharedService,
    private appUtility: AppUtilityService
  ) {
    this.tennant = this.route.snapshot.paramMap.get('company') || localStorage.getItem('company') || 'ashi';
    localStorage.setItem('company', this.tennant);
    this.credentials.tenant = this.tennant;
  }

  ngOnInit(): void {
    this.authenticatedUser = this.appStore.authenticationService.authenticatedUser;
  }

  ngAfterViewInit() {
    const textFields = document.querySelectorAll('.mdc-text-field');
    textFields.forEach(textField => {
      if (window.mdc?.textField?.MDCTextField) {
        window.mdc.textField.MDCTextField.attachTo(textField);
      }
    });
  }

  async changeUsers(): Promise<void> {
    await this.logout();
    this.authenticatedUser = this.appStore.authenticationService.authenticatedUser;
  }

  continueAsAuthenticatedUser(): void {
    this.appUtility.showProgressBar();
    this.router.navigate(['/', this.tennant, 'directory']);
  }

  authenticate(): void {
    this.appUtility.showProgressBar();
    this.appStore.authenticationService.authenticate(this.credentials)
      .then(() => {
        this.router.navigate(['/', this.tennant, 'directory']);
      })
      .catch(error => {
        console.log(error);
        this.appUtility.displayMessage({
          text: error.message || error.error || error.ErrorMessage,
          actionText: "OK",
          duration: 4000
        });
      })
      .finally(() => {
        this.appUtility.hideProgressBar();
      });
  }

  async logout(): Promise<void> {
    await this.appStore.authenticationService.logOut();
  }
}